import React, { useState } from "react";

const DocNameModal = ({
  setShowModal,
  setdocumentName,
  documentName,
  onClick,
  showModal,
}) => {
  const [disabled, setdisabled] = useState(true);
  if (showModal) {
    return (
      <div className="custom-modal-container overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal">
        <div className="custom-modal relative bg-white rounded-lg shadow">
          {/* <div className="flex justify-between items-start p-4 rounded-t border-b">
            <h3 className="text-xl font-semibold text-black-900">
              Upload Certificate
            </h3>
          </div> */}
          {/* ---------- main body--------- */}
          <div className="flex flex-col justify-center pb-6">
            <label className="input-label">Document name</label>
            <input
              type="text"
              className="custom-input"
              placeholder="Enter document name"
              required
              value={documentName}
              onChange={(e) => {
                setdocumentName(e.target.value);
                if (e.target.value.length > 3) setdisabled(false);
                else setdisabled(true);
              }}
            />
          </div>
          <div className="flex justify-betweeen items-center p-6 space-x-2 rounded-b border-t border-gray-200">
            <button
              disabled={disabled}
              onClick={onClick}
              className={disabled ? "disabled-upload-button" : "upload-button"}
            >
              Upload
            </button>
            <button
              onClick={() => setShowModal(false)}
              type="button"
              className="cancel-button"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  } else return null;
};

export default DocNameModal;
